<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Tasks</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="50"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="due_date"
            direction="ASC"
            delete-label="friendly_id"
            :permissions="true"
            :actions="actions"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';

    export default {
        name: "Tasks",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'tasks',
                numberOfFilters: 6,
                pageActions: {
                    buttons: [
                        {
                            label: 'New Task',
                            icon: 'plus',
                            type: 'router-link',
                            link: '/tasks/create',
                            iconClass: 'text-green-600'
                        }
                    ],
                    additional: []
                },
                fields: [
                    {
                        name: '#',
                        column: 'friendly_id',
                        route: '/tasks/{id}/view',
                        linked: true
                    },
                    {
                        name: 'Subject',
                        column: 'subject',
                        sortCol: 'subject',
                        columnClass: 'no-wrap'
                    },
                    {
                        name: 'Assignee',
                        column: 'assignee.name',
                    },
                    {
                        name: 'Type',
                        column: 'type.name',
                    },
                    {
                        name: 'Priority',
                        column: 'priority.name',
                    },
                    {
                        name: 'Status',
                        column: 'status.name',
                    },
                    {
                        name: 'Project',
                        column: 'project.name',
                    },
                    {
                        name: 'Due Date',
                        date: true,
                        format: 'MMMM Do YYYY',
                        column: 'due_date',
                    },
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'tasks.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'tasks.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'tasks.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {

            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/6',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            // Assignee Filter
            const assigneeFilter = {
                label: 'Assignee',
                name: 'assignee',
                type: 'select',
                options: this.$store.getters.systemUsers.map(function (user) {
                    return { label: user.last+' '+user.first, value: user.id };
                }),
                width: 'w-1/6',
                value: this.taskAssigneeValue,
                placeholder: 'Select Assignee...'
            };

            if (this.$store.getters.systemUsers.length === 0){
                this.$store.dispatch('GET_SYSTEM_USERS').then(() => {
                    assigneeFilter.options = this.$store.getters.systemUsers.map(function (user) {
                        return { label: user.last+' '+user.first, value: user.id };
                    });
                    assigneeFilter.value = this.taskAssigneeValue;
                    this.filters.push(assigneeFilter);
                });
            } else {
                this.filters.push(assigneeFilter);
            }

            // Type Filter
            const typeFilter = {
                label: 'Type',
                name: 'type',
                type: 'select',
                options: this.$store.getters.taskTypes.map(function (type) {
                    return { label: type.name, value: type.id };
                }),
                width: 'w-1/6',
                value: this.taskTypeValue,
                placeholder: 'Select Type...'
            };

            if (this.$store.getters.taskTypes.length === 0){
                this.$store.dispatch('GET_TASK_TYPES').then(() => {
                    typeFilter.options = this.$store.getters.taskTypes.map(function (type) {
                        return { label: type.name, value: type.id };
                    });
                    typeFilter.value = this.taskTypeValue;
                    this.filters.push(typeFilter);
                });
            } else {
                this.filters.push(typeFilter);
            }

            // Priority Filter
            const priorityFilter = {
                label: 'Priority',
                name: 'priority',
                type: 'select',
                options: this.$store.getters.taskPriorities.map(function (priority) {
                    return { label: priority.name, value: priority.id };
                }),
                width: 'w-1/6',
                value: this.taskPriorityValue,
                placeholder: 'Select Priority...'
            };

            if (this.$store.getters.taskPriorities.length === 0){
                this.$store.dispatch('GET_TASK_PRIORITIES').then(() => {
                    priorityFilter.options = this.$store.getters.taskPriorities.map(function (priority) {
                        return { label: priority.name, value: priority.id };
                    });
                    priorityFilter.value = this.taskPriorityValue;
                    this.filters.push(priorityFilter);
                });
            } else {
                this.filters.push(priorityFilter);
            }

            // Status Filter
            const statusFilter = {
                label: 'Status',
                name: 'status',
                type: 'select',
                options: this.$store.getters.taskStatuses.map(function (status) {
                    return { label: status.name, value: status.id };
                }),
                width: 'w-1/6',
                value: this.taskStatusValue,
                placeholder: 'Select Status...'
            };

            if (this.$store.getters.taskStatuses.length === 0){
                this.$store.dispatch('GET_TASK_STATUSES').then(() => {
                    statusFilter.options = this.$store.getters.taskStatuses.map(function (status) {
                        return { label: status.name, value: status.id };
                    });
                    statusFilter.value = this.taskStatusValue;
                    this.filters.push(statusFilter);
                });
            } else {
                this.filters.push(statusFilter);
            }

            // Projects Filter
            const projectsFilter = {
                label: 'Project',
                name: 'project',
                type: 'select',
                options: this.$store.getters.taskProjects.filter((project) => project.active).map(function (project) {
                    return { label: project.name, value: project.id };
                }),
                width: 'w-1/6',
                value: this.taskProjectValue,
                placeholder: 'Select Project...'
            };

            if (this.$store.getters.taskProjects.length === 0){
                this.$store.dispatch('GET_TASK_PROJECTS').then(() => {
                    projectsFilter.options = this.$store.getters.taskProjects.filter((project) => project.active).map(function (project) {
                        return { label: project.name, value: project.id };
                    });
                    projectsFilter.value = this.taskProjectValue;
                    this.filters.push(projectsFilter);
                });
            } else {
                this.filters.push(projectsFilter);
            }
        },
        computed: {
            taskStatusValue() {
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.tasks.status)) {
                    return filters.tasks.status;
                } else {
                    return null;
                }
            },
            taskTypeValue() {
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.tasks.type)) {
                    return filters.tasks.type;
                } else {
                    return null;
                }
            },
            taskPriorityValue() {
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.tasks.priority)) {
                    return filters.tasks.priority;
                } else {
                    return null;
                }
            },
            taskAssigneeValue() {
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.tasks.assignee)) {
                    return filters.tasks.assignee;
                } else {
                    return null;
                }
            },
            taskProjectValue() {
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.tasks.project)) {
                    return filters.tasks.project;
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>

</style>
